"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AkitaBox Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.ProcoreEntityTypeEnum = exports.PinFieldDataType = exports.FileActionEnum = exports.AttachmentLinkEnum = exports.AttachmentActionEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AttachmentActionEnum = {
    RemoveLink: 'removeLink'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AttachmentLinkEnum = {
    Assembly: 'assembly',
    Asset: 'asset',
    Checklist: 'checklist',
    Condition: 'condition',
    ConditionAssessment: 'condition_assessment',
    Job: 'job',
    Level: 'level',
    Markup: 'markup',
    Room: 'room',
    Request: 'request',
    Step: 'step',
    Task: 'task',
    Report: 'report'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FileActionEnum = {
    CompleteUpload: 'completeUpload'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PinFieldDataType = {
    Date: 'date',
    DocumentArray: 'document_array',
    Enum: 'enum',
    Float: 'float',
    Int: 'int',
    Level: 'level',
    Paragraph: 'paragraph',
    Room: 'room',
    String: 'string',
    Url: 'url'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProcoreEntityTypeEnum = {
    Image: 'image',
    ProjectFile: 'projectFile',
    DrawingRevision: 'drawingRevision',
    Submittal: 'submittal'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {boolean} [decommissioned]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCount: (organizationId, decommissioned, name, building, pinType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('assetsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/assets?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many attachments exists in the building
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCount: (building, linksEntityId, linksEntityType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCount', 'building', building);
            // verify required parameter 'linksEntityId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCount', 'linksEntityId', linksEntityId);
            // verify required parameter 'linksEntityType' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCount', 'linksEntityType', linksEntityType);
            const localVarPath = `/buildings/{building}/attachments?count=true`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linksEntityId !== undefined) {
                localVarQueryParameter['links.entity_id'] = linksEntityId;
            }
            if (linksEntityType !== undefined) {
                localVarQueryParameter['links.entity_type'] = linksEntityType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new attachment
         * @param {string} building
         * @param {AttachmentsCreateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCreate: (building, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCreate', 'building', building);
            // verify required parameter 'attachment' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCreate', 'attachment', attachment);
            const localVarPath = `/buildings/{building}/attachments`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attachment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get attachments by building, entity id, and entity type
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByBuilding: (building, linksEntityId, linksEntityType, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByBuilding', 'building', building);
            // verify required parameter 'linksEntityId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByBuilding', 'linksEntityId', linksEntityId);
            // verify required parameter 'linksEntityType' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByBuilding', 'linksEntityType', linksEntityType);
            const localVarPath = `/buildings/{building}/attachments`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linksEntityId !== undefined) {
                localVarQueryParameter['links.entity_id'] = linksEntityId;
            }
            if (linksEntityType !== undefined) {
                localVarQueryParameter['links.entity_type'] = linksEntityType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a attachment
         * @param {string} buildingId
         * @param {string} attachmentId
         * @param {AttachmentsUpdateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsUpdate: (buildingId, attachmentId, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsUpdate', 'buildingId', buildingId);
            // verify required parameter 'attachmentId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsUpdate', 'attachmentId', attachmentId);
            // verify required parameter 'attachment' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsUpdate', 'attachment', attachment);
            const localVarPath = `/buildings/{buildingId}/attachments/{attachmentId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attachment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of buildings by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetByOrganization: (organizationId, sort, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/buildings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Cancel the import process for the given importId
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelImport: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('cancelImport', 'importId', importId);
            const localVarPath = `/my_imports/{importId}`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets data from a catalog by its id
         * @param {string} catalogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogGet: (catalogId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogGet', 'catalogId', catalogId);
            const localVarPath = `/catalogs/{catalogId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many catalog items exists
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCount: (catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsCount', 'catalogId', catalogId);
            const localVarPath = `/catalogs/{catalogId}/items?count=true`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }
            if (quantityUnit !== undefined) {
                localVarQueryParameter['quantity_unit'] = quantityUnit;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sizeUnit !== undefined) {
                localVarQueryParameter['size_unit'] = sizeUnit;
            }
            if (frequency !== undefined) {
                localVarQueryParameter['frequency'] = frequency;
            }
            if (materialsUnitCostCents !== undefined) {
                localVarQueryParameter['materials_unit_cost_cents'] = materialsUnitCostCents;
            }
            if (laborUnitCostCents !== undefined) {
                localVarQueryParameter['labor_unit_cost_cents'] = laborUnitCostCents;
            }
            if (equipmentUnitCostCents !== undefined) {
                localVarQueryParameter['equipment_unit_cost_cents'] = equipmentUnitCostCents;
            }
            if (unitCostCents !== undefined) {
                localVarQueryParameter['unit_cost_cents'] = unitCostCents;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new catalog item
         * @param {string} catalogId
         * @param {CatalogItemsCreateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCreate: (catalogId, catalogItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsCreate', 'catalogId', catalogId);
            // verify required parameter 'catalogItem' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsCreate', 'catalogItem', catalogItem);
            const localVarPath = `/catalogs/{catalogId}/items`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogItem, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of items of a catalog
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsGet: (catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsGet', 'catalogId', catalogId);
            const localVarPath = `/catalogs/{catalogId}/items`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }
            if (quantityUnit !== undefined) {
                localVarQueryParameter['quantity_unit'] = quantityUnit;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sizeUnit !== undefined) {
                localVarQueryParameter['size_unit'] = sizeUnit;
            }
            if (frequency !== undefined) {
                localVarQueryParameter['frequency'] = frequency;
            }
            if (materialsUnitCostCents !== undefined) {
                localVarQueryParameter['materials_unit_cost_cents'] = materialsUnitCostCents;
            }
            if (laborUnitCostCents !== undefined) {
                localVarQueryParameter['labor_unit_cost_cents'] = laborUnitCostCents;
            }
            if (equipmentUnitCostCents !== undefined) {
                localVarQueryParameter['equipment_unit_cost_cents'] = equipmentUnitCostCents;
            }
            if (unitCostCents !== undefined) {
                localVarQueryParameter['unit_cost_cents'] = unitCostCents;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {CatalogItemsUpdateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsUpdate: (catalogId, itemId, catalogItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsUpdate', 'catalogId', catalogId);
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsUpdate', 'itemId', itemId);
            // verify required parameter 'catalogItem' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsUpdate', 'catalogItem', catalogItem);
            const localVarPath = `/catalogs/{catalogId}/items/{itemId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogItem, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a catalog
         * @param {string} catalogId
         * @param {CatalogUpdateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogUpdate: (catalogId, catalog, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogUpdate', 'catalogId', catalogId);
            // verify required parameter 'catalog' is not null or undefined
            (0, common_1.assertParamExists)('catalogUpdate', 'catalog', catalog);
            const localVarPath = `/catalogs/{catalogId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalog, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many catalogs exists
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCount: (name, modifiedDateMs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/catalogs?count=true`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (modifiedDateMs !== undefined) {
                localVarQueryParameter['modified_date_ms'] = modifiedDateMs;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new catalog
         * @param {CatalogsCreateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCreate: (catalog, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalog' is not null or undefined
            (0, common_1.assertParamExists)('catalogsCreate', 'catalog', catalog);
            const localVarPath = `/catalogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalog, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of Catalogs
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsGet: (name, modifiedDateMs, limit, sort, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/catalogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (modifiedDateMs !== undefined) {
                localVarQueryParameter['modified_date_ms'] = modifiedDateMs;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch token for CKEditor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorGetToken: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/third_party/ckeditor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of documents
         * @param {string} building
         * @param {boolean} [archived]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [extension]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGetByBuilding: (building, archived, limit, skip, sort, name, extension, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('documentsGetByBuilding', 'building', building);
            const localVarPath = `/buildings/{building}/docs`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (extension !== undefined) {
                localVarQueryParameter['extension'] = extension;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload a document
         * @param {string} building
         * @param {File} file
         * @param {boolean} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUpload: (building, file, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('documentsUpload', 'building', building);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('documentsUpload', 'file', file);
            const localVarPath = `/buildings/{building}/docs`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (attachment !== undefined) {
                localVarFormParams.append('attachment', attachment);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new file upload url
         * @param {string} organization
         * @param {FileCreateRequest} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileCreate: (organization, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('fileCreate', 'organization', organization);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('fileCreate', 'file', file);
            const localVarPath = `/organizations/{organization}/files`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(file, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Mark file upload as completed
         * @param {string} organization
         * @param {string} file
         * @param {FilesCompleteUploadRequest} fileAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesCompleteUpload: (organization, file, fileAction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('filesCompleteUpload', 'organization', organization);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('filesCompleteUpload', 'file', file);
            // verify required parameter 'fileAction' is not null or undefined
            (0, common_1.assertParamExists)('filesCompleteUpload', 'fileAction', fileAction);
            const localVarPath = `/organizations/{organization}/files/{file}`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)))
                .replace(`{${"file"}}`, encodeURIComponent(String(file)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileAction, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of feature flags that are globally AND organizationally enable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the CSV rows result for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSVResult: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('getCSVResult', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/rows_csv`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the rows for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [startKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRows: (importId, status, limit, sort, startKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('getRows', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/rows`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (startKey !== undefined) {
                localVarQueryParameter['start_key'] = startKey;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the current logged user identity data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Process the given CSV and bulk add the items for the given import_entity
         * @param {string} targetId ID of the target entity that the items will be imported.
         * @param {string} targetEntity Name of the target entity that the items will be imported. [e.g.: catalog]
         * @param {string} importEntity Name of the entity (items) that will be imported. [e.g.: catalog-items]
         * @param {File} files The file (csv) that contains the items that will be imported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCSV: (targetId, targetEntity, importEntity, files, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'targetId' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'targetId', targetId);
            // verify required parameter 'targetEntity' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'targetEntity', targetEntity);
            // verify required parameter 'importEntity' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'importEntity', importEntity);
            // verify required parameter 'files' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'files', files);
            const localVarPath = `/my_imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (targetId !== undefined) {
                localVarFormParams.append('target_id', targetId);
            }
            if (targetEntity !== undefined) {
                localVarFormParams.append('target_entity', targetEntity);
            }
            if (importEntity !== undefined) {
                localVarFormParams.append('import_entity', importEntity);
            }
            if (files !== undefined) {
                localVarFormParams.append('files', files);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Checks the rows stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsStats: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('importRowsStats', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/rows_stats`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of organizations
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet: (subdomain, subdomainKey, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (subdomain !== undefined) {
                localVarQueryParameter['subdomain'] = subdomain;
            }
            if (subdomainKey !== undefined) {
                localVarQueryParameter['subdomain_key'] = subdomainKey;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many pin type categories exists in the organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesCount: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('pinTypesCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/pin_types?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of pin type categories by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetByOrganization: (organizationId, limit, skip, building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('pinTypesGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/pin_types`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of procore companies the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetMyCompanies: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/third_party/procore/my_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of procore projects in the provided company the user has access to
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProjectsByCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            (0, common_1.assertParamExists)('procoreGetProjectsByCompany', 'companyId', companyId);
            const localVarPath = `/third_party/procore/my_companies/{companyId}/projects`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Forwards the provided endpoint with any params to Procore API and returns data response
         * @param {string} endpoint
         * @param {string} companyId
         * @param {number} [page]
         * @param {number} [projectId]
         * @param {number} [perPage]
         * @param {string} [filterType]
         * @param {number} [drawingAreaId]
         * @param {number} [drawingDisciplineId]
         * @param {string} [drawingSetId]
         * @param {number} [filtersSpecificationSectionId]
         * @param {number} [filtersStatusId]
         * @param {string} [filtersDocumentType]
         * @param {string} [filtersFolderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProxy: (endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'endpoint' is not null or undefined
            (0, common_1.assertParamExists)('procoreGetProxy', 'endpoint', endpoint);
            // verify required parameter 'companyId' is not null or undefined
            (0, common_1.assertParamExists)('procoreGetProxy', 'companyId', companyId);
            const localVarPath = `/third_party/procore/proxy/{endpoint}`
                .replace(`{${"endpoint"}}`, encodeURIComponent(String(endpoint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (filterType !== undefined) {
                localVarQueryParameter['filter_type'] = filterType;
            }
            if (drawingAreaId !== undefined) {
                localVarQueryParameter['drawing_area_id'] = drawingAreaId;
            }
            if (drawingDisciplineId !== undefined) {
                localVarQueryParameter['drawing_discipline_id'] = drawingDisciplineId;
            }
            if (drawingSetId !== undefined) {
                localVarQueryParameter['drawing_set_id'] = drawingSetId;
            }
            if (filtersSpecificationSectionId !== undefined) {
                localVarQueryParameter['filters[specification_section_id]'] = filtersSpecificationSectionId;
            }
            if (filtersStatusId !== undefined) {
                localVarQueryParameter['filters[status_id]'] = filtersStatusId;
            }
            if (filtersDocumentType !== undefined) {
                localVarQueryParameter['filters[document_type]'] = filtersDocumentType;
            }
            if (filtersFolderId !== undefined) {
                localVarQueryParameter['filters[folder_id]'] = filtersFolderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Checks if the AkitaBox app is installed for the provided company and project (optionally)
         * @param {string} companyId
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreIsAppInstalled: (companyId, projectId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            (0, common_1.assertParamExists)('procoreIsAppInstalled', 'companyId', companyId);
            const localVarPath = `/third_party/procore/is_app_installed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiates procore oauth 2.0 flow
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreOauth: (redirectUrl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'redirectUrl' is not null or undefined
            (0, common_1.assertParamExists)('procoreOauth', 'redirectUrl', redirectUrl);
            const localVarPath = `/third_party/procore/oauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirect_url'] = redirectUrl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Pull files from Procore into AkitaBox
         * @param {string} buildingId
         * @param {string} organizationId
         * @param {ProcorePullFilesRequest} procorePullFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procorePullFiles: (buildingId, organizationId, procorePullFilesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('procorePullFiles', 'buildingId', buildingId);
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('procorePullFiles', 'organizationId', organizationId);
            // verify required parameter 'procorePullFilesRequest' is not null or undefined
            (0, common_1.assertParamExists)('procorePullFiles', 'procorePullFilesRequest', procorePullFilesRequest);
            const localVarPath = `/third_party/procore/{organizationId}/pull/{buildingId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(procorePullFilesRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report content by report id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentGetById: (organizationId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentGetById', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentGetById', 'reportId', reportId);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report content
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportContentUpdateRequest} reportContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentUpdate: (organizationId, reportId, reportContent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentUpdate', 'reportId', reportId);
            // verify required parameter 'reportContent' is not null or undefined
            (0, common_1.assertParamExists)('reportContentUpdate', 'reportContent', reportContent);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many reports exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCount: (organizationId, name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/reports?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new report
         * @param {string} organizationId
         * @param {ReportsCreateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate: (organizationId, report, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsCreate', 'organizationId', organizationId);
            // verify required parameter 'report' is not null or undefined
            (0, common_1.assertParamExists)('reportsCreate', 'report', report);
            const localVarPath = `/organizations/{organizationId}/reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(report, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete: (organizationId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsDelete', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportsDelete', 'reportId', reportId);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report by its id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetById: (organizationId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsGetById', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportsGetById', 'reportId', reportId);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of reports by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {boolean} [insensitive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetByOrganization: (organizationId, name, sort, limit, skip, insensitive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (insensitive !== undefined) {
                localVarQueryParameter['insensitive'] = insensitive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportsUpdateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate: (organizationId, reportId, report, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportsUpdate', 'reportId', reportId);
            // verify required parameter 'report' is not null or undefined
            (0, common_1.assertParamExists)('reportsUpdate', 'report', report);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(report, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the tag categories for a building
         * @param {string} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGetByBuilding: (building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('tagsGetByBuilding', 'building', building);
            const localVarPath = `/buildings/{building}/tags`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the current organization user data
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetByOrganization: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('usersGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/user`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssets: (orgId, sort, decommissioned, insensitive, name, building, pinType, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('webGetAssets', 'orgId', orgId);
            const localVarPath = `/organizations/{orgId}/web/assets`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            if (insensitive !== undefined) {
                localVarQueryParameter['insensitive'] = insensitive;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {boolean} [decommissioned]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCount(organizationId, decommissioned, name, building, pinType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assetsCount(organizationId, decommissioned, name, building, pinType, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many attachments exists in the building
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCount(building, linksEntityId, linksEntityType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsCount(building, linksEntityId, linksEntityType, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create new attachment
         * @param {string} building
         * @param {AttachmentsCreateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCreate(building, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsCreate(building, attachment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get attachments by building, entity id, and entity type
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByBuilding(building, linksEntityId, linksEntityType, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsGetByBuilding(building, linksEntityId, linksEntityType, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a attachment
         * @param {string} buildingId
         * @param {string} attachmentId
         * @param {AttachmentsUpdateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsUpdate(buildingId, attachmentId, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsUpdate(buildingId, attachmentId, attachment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of buildings by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetByOrganization(organizationId, sort, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buildingsGetByOrganization(organizationId, sort, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Cancel the import process for the given importId
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelImport(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelImport(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets data from a catalog by its id
         * @param {string} catalogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogGet(catalogId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogGet(catalogId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many catalog items exists
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new catalog item
         * @param {string} catalogId
         * @param {CatalogItemsCreateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCreate(catalogId, catalogItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsCreate(catalogId, catalogItem, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of items of a catalog
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {CatalogItemsUpdateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsUpdate(catalogId, itemId, catalogItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsUpdate(catalogId, itemId, catalogItem, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a catalog
         * @param {string} catalogId
         * @param {CatalogUpdateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogUpdate(catalogId, catalog, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogUpdate(catalogId, catalog, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many catalogs exists
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCount(name, modifiedDateMs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogsCount(name, modifiedDateMs, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new catalog
         * @param {CatalogsCreateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCreate(catalog, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogsCreate(catalog, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of Catalogs
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsGet(name, modifiedDateMs, limit, sort, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogsGet(name, modifiedDateMs, limit, sort, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch token for CKEditor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorGetToken(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ckeditorGetToken(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get list of documents
         * @param {string} building
         * @param {boolean} [archived]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [extension]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Upload a document
         * @param {string} building
         * @param {File} file
         * @param {boolean} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUpload(building, file, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.documentsUpload(building, file, attachment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create new file upload url
         * @param {string} organization
         * @param {FileCreateRequest} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileCreate(organization, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fileCreate(organization, file, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Mark file upload as completed
         * @param {string} organization
         * @param {string} file
         * @param {FilesCompleteUploadRequest} fileAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesCompleteUpload(organization, file, fileAction, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.filesCompleteUpload(organization, file, fileAction, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of feature flags that are globally AND organizationally enable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.flagsGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the CSV rows result for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSVResult(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCSVResult(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the rows for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [startKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRows(importId, status, limit, sort, startKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRows(importId, status, limit, sort, startKey, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the current logged user identity data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.identityGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Process the given CSV and bulk add the items for the given import_entity
         * @param {string} targetId ID of the target entity that the items will be imported.
         * @param {string} targetEntity Name of the target entity that the items will be imported. [e.g.: catalog]
         * @param {string} importEntity Name of the entity (items) that will be imported. [e.g.: catalog-items]
         * @param {File} files The file (csv) that contains the items that will be imported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCSV(targetId, targetEntity, importEntity, files, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importCSV(targetId, targetEntity, importEntity, files, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Checks the rows stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsStats(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importRowsStats(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of organizations
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet(subdomain, subdomainKey, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsGet(subdomain, subdomainKey, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many pin type categories exists in the organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesCount(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pinTypesCount(organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of pin type categories by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetByOrganization(organizationId, limit, skip, building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pinTypesGetByOrganization(organizationId, limit, skip, building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of procore companies the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetMyCompanies(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreGetMyCompanies(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of procore projects in the provided company the user has access to
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProjectsByCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreGetProjectsByCompany(companyId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Forwards the provided endpoint with any params to Procore API and returns data response
         * @param {string} endpoint
         * @param {string} companyId
         * @param {number} [page]
         * @param {number} [projectId]
         * @param {number} [perPage]
         * @param {string} [filterType]
         * @param {number} [drawingAreaId]
         * @param {number} [drawingDisciplineId]
         * @param {string} [drawingSetId]
         * @param {number} [filtersSpecificationSectionId]
         * @param {number} [filtersStatusId]
         * @param {string} [filtersDocumentType]
         * @param {string} [filtersFolderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Checks if the AkitaBox app is installed for the provided company and project (optionally)
         * @param {string} companyId
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreIsAppInstalled(companyId, projectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreIsAppInstalled(companyId, projectId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Initiates procore oauth 2.0 flow
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreOauth(redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreOauth(redirectUrl, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Pull files from Procore into AkitaBox
         * @param {string} buildingId
         * @param {string} organizationId
         * @param {ProcorePullFilesRequest} procorePullFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report content by report id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentGetById(organizationId, reportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportContentGetById(organizationId, reportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report content
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportContentUpdateRequest} reportContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentUpdate(organizationId, reportId, reportContent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportContentUpdate(organizationId, reportId, reportContent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many reports exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCount(organizationId, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsCount(organizationId, name, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new report
         * @param {string} organizationId
         * @param {ReportsCreateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate(organizationId, report, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsCreate(organizationId, report, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete(organizationId, reportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsDelete(organizationId, reportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report by its id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetById(organizationId, reportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsGetById(organizationId, reportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of reports by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {boolean} [insensitive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportsUpdateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate(organizationId, reportId, report, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsUpdate(organizationId, reportId, report, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the tag categories for a building
         * @param {string} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGetByBuilding(building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsGetByBuilding(building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the current organization user data
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetByOrganization(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersGetByOrganization(organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssets(orgId, sort, decommissioned, insensitive, name, building, pinType, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetAssets(orgId, sort, decommissioned, insensitive, name, building, pinType, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {boolean} [decommissioned]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCount(organizationId, decommissioned, name, building, pinType, options) {
            return localVarFp.assetsCount(organizationId, decommissioned, name, building, pinType, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many attachments exists in the building
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCount(building, linksEntityId, linksEntityType, options) {
            return localVarFp.attachmentsCount(building, linksEntityId, linksEntityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new attachment
         * @param {string} building
         * @param {AttachmentsCreateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCreate(building, attachment, options) {
            return localVarFp.attachmentsCreate(building, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Get attachments by building, entity id, and entity type
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByBuilding(building, linksEntityId, linksEntityType, limit, skip, options) {
            return localVarFp.attachmentsGetByBuilding(building, linksEntityId, linksEntityType, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a attachment
         * @param {string} buildingId
         * @param {string} attachmentId
         * @param {AttachmentsUpdateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsUpdate(buildingId, attachmentId, attachment, options) {
            return localVarFp.attachmentsUpdate(buildingId, attachmentId, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of buildings by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetByOrganization(organizationId, sort, limit, skip, options) {
            return localVarFp.buildingsGetByOrganization(organizationId, sort, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel the import process for the given importId
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelImport(importId, options) {
            return localVarFp.cancelImport(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets data from a catalog by its id
         * @param {string} catalogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogGet(catalogId, options) {
            return localVarFp.catalogGet(catalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many catalog items exists
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return localVarFp.catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new catalog item
         * @param {string} catalogId
         * @param {CatalogItemsCreateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCreate(catalogId, catalogItem, options) {
            return localVarFp.catalogItemsCreate(catalogId, catalogItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of items of a catalog
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return localVarFp.catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {CatalogItemsUpdateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsUpdate(catalogId, itemId, catalogItem, options) {
            return localVarFp.catalogItemsUpdate(catalogId, itemId, catalogItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a catalog
         * @param {string} catalogId
         * @param {CatalogUpdateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogUpdate(catalogId, catalog, options) {
            return localVarFp.catalogUpdate(catalogId, catalog, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many catalogs exists
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCount(name, modifiedDateMs, options) {
            return localVarFp.catalogsCount(name, modifiedDateMs, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new catalog
         * @param {CatalogsCreateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCreate(catalog, options) {
            return localVarFp.catalogsCreate(catalog, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of Catalogs
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsGet(name, modifiedDateMs, limit, sort, skip, options) {
            return localVarFp.catalogsGet(name, modifiedDateMs, limit, sort, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch token for CKEditor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorGetToken(options) {
            return localVarFp.ckeditorGetToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of documents
         * @param {string} building
         * @param {boolean} [archived]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [extension]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options) {
            return localVarFp.documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a document
         * @param {string} building
         * @param {File} file
         * @param {boolean} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUpload(building, file, attachment, options) {
            return localVarFp.documentsUpload(building, file, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new file upload url
         * @param {string} organization
         * @param {FileCreateRequest} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileCreate(organization, file, options) {
            return localVarFp.fileCreate(organization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark file upload as completed
         * @param {string} organization
         * @param {string} file
         * @param {FilesCompleteUploadRequest} fileAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesCompleteUpload(organization, file, fileAction, options) {
            return localVarFp.filesCompleteUpload(organization, file, fileAction, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of feature flags that are globally AND organizationally enable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagsGet(options) {
            return localVarFp.flagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the CSV rows result for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSVResult(importId, options) {
            return localVarFp.getCSVResult(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the rows for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [startKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRows(importId, status, limit, sort, startKey, options) {
            return localVarFp.getRows(importId, status, limit, sort, startKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the current logged user identity data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGet(options) {
            return localVarFp.identityGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Process the given CSV and bulk add the items for the given import_entity
         * @param {string} targetId ID of the target entity that the items will be imported.
         * @param {string} targetEntity Name of the target entity that the items will be imported. [e.g.: catalog]
         * @param {string} importEntity Name of the entity (items) that will be imported. [e.g.: catalog-items]
         * @param {File} files The file (csv) that contains the items that will be imported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCSV(targetId, targetEntity, importEntity, files, options) {
            return localVarFp.importCSV(targetId, targetEntity, importEntity, files, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the rows stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsStats(importId, options) {
            return localVarFp.importRowsStats(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of organizations
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet(subdomain, subdomainKey, limit, skip, options) {
            return localVarFp.organizationsGet(subdomain, subdomainKey, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many pin type categories exists in the organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesCount(organizationId, options) {
            return localVarFp.pinTypesCount(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of pin type categories by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetByOrganization(organizationId, limit, skip, building, options) {
            return localVarFp.pinTypesGetByOrganization(organizationId, limit, skip, building, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of procore companies the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetMyCompanies(options) {
            return localVarFp.procoreGetMyCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of procore projects in the provided company the user has access to
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProjectsByCompany(companyId, options) {
            return localVarFp.procoreGetProjectsByCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Forwards the provided endpoint with any params to Procore API and returns data response
         * @param {string} endpoint
         * @param {string} companyId
         * @param {number} [page]
         * @param {number} [projectId]
         * @param {number} [perPage]
         * @param {string} [filterType]
         * @param {number} [drawingAreaId]
         * @param {number} [drawingDisciplineId]
         * @param {string} [drawingSetId]
         * @param {number} [filtersSpecificationSectionId]
         * @param {number} [filtersStatusId]
         * @param {string} [filtersDocumentType]
         * @param {string} [filtersFolderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options) {
            return localVarFp.procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if the AkitaBox app is installed for the provided company and project (optionally)
         * @param {string} companyId
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreIsAppInstalled(companyId, projectId, options) {
            return localVarFp.procoreIsAppInstalled(companyId, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates procore oauth 2.0 flow
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreOauth(redirectUrl, options) {
            return localVarFp.procoreOauth(redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * Pull files from Procore into AkitaBox
         * @param {string} buildingId
         * @param {string} organizationId
         * @param {ProcorePullFilesRequest} procorePullFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options) {
            return localVarFp.procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report content by report id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentGetById(organizationId, reportId, options) {
            return localVarFp.reportContentGetById(organizationId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report content
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportContentUpdateRequest} reportContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentUpdate(organizationId, reportId, reportContent, options) {
            return localVarFp.reportContentUpdate(organizationId, reportId, reportContent, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many reports exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCount(organizationId, name, options) {
            return localVarFp.reportsCount(organizationId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new report
         * @param {string} organizationId
         * @param {ReportsCreateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate(organizationId, report, options) {
            return localVarFp.reportsCreate(organizationId, report, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete(organizationId, reportId, options) {
            return localVarFp.reportsDelete(organizationId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report by its id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetById(organizationId, reportId, options) {
            return localVarFp.reportsGetById(organizationId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of reports by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {boolean} [insensitive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options) {
            return localVarFp.reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportsUpdateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate(organizationId, reportId, report, options) {
            return localVarFp.reportsUpdate(organizationId, reportId, report, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the tag categories for a building
         * @param {string} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGetByBuilding(building, options) {
            return localVarFp.tagsGetByBuilding(building, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the current organization user data
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetByOrganization(organizationId, options) {
            return localVarFp.usersGetByOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssets(orgId, sort, decommissioned, insensitive, name, building, pinType, limit, skip, options) {
            return localVarFp.webGetAssets(orgId, sort, decommissioned, insensitive, name, building, pinType, limit, skip, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     * Counts how many assets exists in the organization
     * @param {DefaultApiAssetsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assetsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).assetsCount(requestParameters.organizationId, requestParameters.decommissioned, requestParameters.name, requestParameters.building, requestParameters.pinType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many attachments exists in the building
     * @param {DefaultApiAttachmentsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsCount(requestParameters.building, requestParameters.linksEntityId, requestParameters.linksEntityType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new attachment
     * @param {DefaultApiAttachmentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsCreate(requestParameters.building, requestParameters.attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get attachments by building, entity id, and entity type
     * @param {DefaultApiAttachmentsGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsGetByBuilding(requestParameters.building, requestParameters.linksEntityId, requestParameters.linksEntityType, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a attachment
     * @param {DefaultApiAttachmentsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsUpdate(requestParameters.buildingId, requestParameters.attachmentId, requestParameters.attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of buildings by organization
     * @param {DefaultApiBuildingsGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    buildingsGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).buildingsGetByOrganization(requestParameters.organizationId, requestParameters.sort, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cancel the import process for the given importId
     * @param {DefaultApiCancelImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelImport(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).cancelImport(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets data from a catalog by its id
     * @param {DefaultApiCatalogGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogGet(requestParameters.catalogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many catalog items exists
     * @param {DefaultApiCatalogItemsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsCount(requestParameters.catalogId, requestParameters.itemId, requestParameters.name, requestParameters.description, requestParameters.quantityUnit, requestParameters.size, requestParameters.sizeUnit, requestParameters.frequency, requestParameters.materialsUnitCostCents, requestParameters.laborUnitCostCents, requestParameters.equipmentUnitCostCents, requestParameters.unitCostCents, requestParameters.limit, requestParameters.sort, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new catalog item
     * @param {DefaultApiCatalogItemsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsCreate(requestParameters.catalogId, requestParameters.catalogItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of items of a catalog
     * @param {DefaultApiCatalogItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsGet(requestParameters.catalogId, requestParameters.itemId, requestParameters.name, requestParameters.description, requestParameters.quantityUnit, requestParameters.size, requestParameters.sizeUnit, requestParameters.frequency, requestParameters.materialsUnitCostCents, requestParameters.laborUnitCostCents, requestParameters.equipmentUnitCostCents, requestParameters.unitCostCents, requestParameters.limit, requestParameters.sort, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a catalog item
     * @param {DefaultApiCatalogItemsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsUpdate(requestParameters.catalogId, requestParameters.itemId, requestParameters.catalogItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a catalog
     * @param {DefaultApiCatalogUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogUpdate(requestParameters.catalogId, requestParameters.catalog, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many catalogs exists
     * @param {DefaultApiCatalogsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogsCount(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogsCount(requestParameters.name, requestParameters.modifiedDateMs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new catalog
     * @param {DefaultApiCatalogsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogsCreate(requestParameters.catalog, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of Catalogs
     * @param {DefaultApiCatalogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogsGet(requestParameters.name, requestParameters.modifiedDateMs, requestParameters.limit, requestParameters.sort, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch token for CKEditor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    ckeditorGetToken(options) {
        return (0, exports.DefaultApiFp)(this.configuration).ckeditorGetToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of documents
     * @param {DefaultApiDocumentsGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentsGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentsGetByBuilding(requestParameters.building, requestParameters.archived, requestParameters.limit, requestParameters.skip, requestParameters.sort, requestParameters.name, requestParameters.extension, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a document
     * @param {DefaultApiDocumentsUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentsUpload(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentsUpload(requestParameters.building, requestParameters.file, requestParameters.attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new file upload url
     * @param {DefaultApiFileCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    fileCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).fileCreate(requestParameters.organization, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Mark file upload as completed
     * @param {DefaultApiFilesCompleteUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    filesCompleteUpload(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).filesCompleteUpload(requestParameters.organization, requestParameters.file, requestParameters.fileAction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of feature flags that are globally AND organizationally enable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    flagsGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).flagsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the CSV rows result for the given import
     * @param {DefaultApiGetCSVResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCSVResult(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCSVResult(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the rows for the given import
     * @param {DefaultApiGetRowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getRows(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getRows(requestParameters.importId, requestParameters.status, requestParameters.limit, requestParameters.sort, requestParameters.startKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the current logged user identity data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    identityGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).identityGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Process the given CSV and bulk add the items for the given import_entity
     * @param {DefaultApiImportCSVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importCSV(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).importCSV(requestParameters.targetId, requestParameters.targetEntity, requestParameters.importEntity, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Checks the rows stats for the given import
     * @param {DefaultApiImportRowsStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importRowsStats(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).importRowsStats(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of organizations
     * @param {DefaultApiOrganizationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    organizationsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).organizationsGet(requestParameters.subdomain, requestParameters.subdomainKey, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many pin type categories exists in the organization
     * @param {DefaultApiPinTypesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    pinTypesCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).pinTypesCount(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of pin type categories by organization
     * @param {DefaultApiPinTypesGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    pinTypesGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).pinTypesGetByOrganization(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of procore companies the user has access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreGetMyCompanies(options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreGetMyCompanies(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of procore projects in the provided company the user has access to
     * @param {DefaultApiProcoreGetProjectsByCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreGetProjectsByCompany(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreGetProjectsByCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Forwards the provided endpoint with any params to Procore API and returns data response
     * @param {DefaultApiProcoreGetProxyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreGetProxy(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreGetProxy(requestParameters.endpoint, requestParameters.companyId, requestParameters.page, requestParameters.projectId, requestParameters.perPage, requestParameters.filterType, requestParameters.drawingAreaId, requestParameters.drawingDisciplineId, requestParameters.drawingSetId, requestParameters.filtersSpecificationSectionId, requestParameters.filtersStatusId, requestParameters.filtersDocumentType, requestParameters.filtersFolderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Checks if the AkitaBox app is installed for the provided company and project (optionally)
     * @param {DefaultApiProcoreIsAppInstalledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreIsAppInstalled(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreIsAppInstalled(requestParameters.companyId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiates procore oauth 2.0 flow
     * @param {DefaultApiProcoreOauthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreOauth(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreOauth(requestParameters.redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Pull files from Procore into AkitaBox
     * @param {DefaultApiProcorePullFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procorePullFiles(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procorePullFiles(requestParameters.buildingId, requestParameters.organizationId, requestParameters.procorePullFilesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report content by report id
     * @param {DefaultApiReportContentGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportContentGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportContentGetById(requestParameters.organizationId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report content
     * @param {DefaultApiReportContentUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportContentUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportContentUpdate(requestParameters.organizationId, requestParameters.reportId, requestParameters.reportContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many reports exists in the organization
     * @param {DefaultApiReportsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsCount(requestParameters.organizationId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new report
     * @param {DefaultApiReportsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsCreate(requestParameters.organizationId, requestParameters.report, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a report
     * @param {DefaultApiReportsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsDelete(requestParameters.organizationId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report by its id
     * @param {DefaultApiReportsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsGetById(requestParameters.organizationId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of reports by organization
     * @param {DefaultApiReportsGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsGetByOrganization(requestParameters.organizationId, requestParameters.name, requestParameters.sort, requestParameters.limit, requestParameters.skip, requestParameters.insensitive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report
     * @param {DefaultApiReportsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsUpdate(requestParameters.organizationId, requestParameters.reportId, requestParameters.report, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the tag categories for a building
     * @param {DefaultApiTagsGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    tagsGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).tagsGetByBuilding(requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the current organization user data
     * @param {DefaultApiUsersGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    usersGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).usersGetByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * BFF Route for web-client asset list
     * @param {DefaultApiWebGetAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetAssets(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetAssets(requestParameters.orgId, requestParameters.sort, requestParameters.decommissioned, requestParameters.insensitive, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map